"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLDClient = exports.useFlags = exports.shareFeatureFlaggingContext = exports.updateUser = exports.useFeatureFlag = exports.FeatureFlagProvider = void 0;
const React = __importStar(require("react"));
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
Object.defineProperty(exports, "useFlags", { enumerable: true, get: function () { return launchdarkly_react_client_sdk_1.useFlags; } });
Object.defineProperty(exports, "useLDClient", { enumerable: true, get: function () { return launchdarkly_react_client_sdk_1.useLDClient; } });
const mf_host_1 = require("@4r/mf-host");
const module_common_feature_flags_mf_app_1 = require("@4r/module-common-feature-flags-mf-app");
const jwt_utils_1 = require("./jwt-utils");
const ReactLDContext = React.createContext({ flags: {} });
function ReactLDContextProvider(props) {
    const flags = (0, launchdarkly_react_client_sdk_1.useFlags)();
    const value = React.useMemo(() => ({ flags }), [flags]);
    return React.createElement(ReactLDContext.Provider, { value: value }, props.children);
}
function createLDContext(userId) {
    const ctx = {
        kind: 'user',
        key: userId,
        anonymous: !userId,
    };
    return ctx;
}
function LDUserUpdater({ userId, children }) {
    const ldClient = (0, launchdarkly_react_client_sdk_1.useLDClient)();
    React.useEffect(() => {
        ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify(createLDContext(userId));
    }, [userId]);
    return React.createElement(React.Fragment, null, children);
}
function FeatureFlagProvider(props) {
    var _a;
    const ldContext = React.useMemo(() => {
        var _a, _b;
        // we prefer the app provided IdP ID, else we fall back on the sub claim
        const userId = (_b = (_a = props.identityProviderUserId) !== null && _a !== void 0 ? _a : (0, jwt_utils_1.readSubId)(props.identityTokenKey)) !== null && _b !== void 0 ? _b : undefined;
        return createLDContext(userId);
    }, [props.identityProviderUserId, props.identityTokenKey]);
    return (React.createElement(launchdarkly_react_client_sdk_1.LDProvider, { clientSideID: props.clientSideId, reactOptions: { useCamelCaseFlagKeys: false }, context: ldContext },
        React.createElement(LDUserUpdater, { userId: (_a = props.identityProviderUserId) !== null && _a !== void 0 ? _a : undefined },
            React.createElement(ReactLDContextProvider, null, props.children))));
}
exports.FeatureFlagProvider = FeatureFlagProvider;
function useFeatureFlag(key) {
    var _a;
    const flags = (_a = (0, launchdarkly_react_client_sdk_1.useFlags)()) !== null && _a !== void 0 ? _a : {};
    return flags[key];
}
exports.useFeatureFlag = useFeatureFlag;
/** @deprecated UserId is updated automatically, it's not needed anymore as the FeatureFlagProvider prides means to update it */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function updateUser(identityProviderUserId) {
    // eslint-disable-next-line no-console
    console.warn('The updateUser is deprecated');
    return Promise.resolve();
}
exports.updateUser = updateUser;
function shareFeatureFlaggingContext() {
    (0, mf_host_1.shareComponent)(module_common_feature_flags_mf_app_1.LdContextKey, ReactLDContext);
}
exports.shareFeatureFlaggingContext = shareFeatureFlaggingContext;
